import { apiOwner, baasOwner, externalAPICall } from './apis';

export const LINNAEUS ='LINNAEUS';

const vetstoriaHeaders = {
  "Clinic-Hash": "6266aea794624",
  "Vetstoria-Instance": "DEMO"
}

const LLMAPIHeader = {
  "API-Key": `${process.env.REACT_APP_LLM_API_KEY}`,
};

export function putPracticeGroup(ownersProfile, data) {
  return apiOwner.put(`baas/users/${ownersProfile.kinshipId}/partners/${data.id}`, data);
}

export function clearPracticeGroup(ownersProfile, data) {
  return apiOwner.delete(`baas/users/${ownersProfile.kinshipId}/partners/${data.id}`);
}

export function postPracticeGroup(ownersProfile, data) {
  return apiOwner.post(`baas/users/${ownersProfile.kinshipId}/partners`, data);
}

function getVetstoriaHeaders(vetstoriaHeadersArg) {
  return vetstoriaHeadersArg ? vetstoriaHeadersArg : vetstoriaHeaders;
}

export async function updatePetProfile(
  updatedPet,
  extraFields,
) {
  const newPet = await baasOwner.patch(`pet_profile/${updatedPet.kinshipPetId}`,
    extraFields,
  );

  console.log("updatePetProfile->newPet =>", { ...updatedPet, ...newPet });

  return { ...updatedPet, ...newPet };
};

export async function updateProfile(
  updatedUser,
  extraFields,
) {
  const newUser = await apiOwner.patch(`baas/users/${updatedUser.kinshipId}`,
    extraFields,
  );

  console.log("updateProfile->newUser =>", updatedUser.kinshipId, extraFields, { ...updatedUser, ...newUser });

  return { ...updatedUser, ...newUser };
};

export async function getPracticeGroups(partnerCode, kinshipId, vetstoriaHeadersArg) {
  return await baasOwner.get(`vet-practice-groups?partnerCode=${partnerCode}&practiceGroupId=${kinshipId}`, {
    headers: {
      ...getVetstoriaHeaders(vetstoriaHeadersArg),
    }});
}

export async function getVeterinarySpecialists(partnerCode, kinshipId, vetstoriaHeadersArg) {
  let url = `vet-practices?partnerCode=${partnerCode}`;

  if(kinshipId !== '') {
    url = `${url}&practiceGroupId=${kinshipId}`
  }

  return await baasOwner.get(url, {
    headers: {
      ...getVetstoriaHeaders(vetstoriaHeadersArg),
    }});
}

export async function getClinicSummaryLLM(
  vetstoriaClinicHash,
  phone
) {
  const url = `https://kinship-backend-proxy-411518714997.us-central1.run.app/infer-clinic-summary/${vetstoriaClinicHash}`;
  const body = phone ? { phone } : {};
  const config = { 
    headers: LLMAPIHeader,
    timeout: 1000000, 
  }; 

  return await externalAPICall.post(url, body, config);
}

export async function getPracticeLocations(vetstoriaHeadersArg) {
  return await baasOwner.get('vetstoria/locations', {
    headers: {
      ...getVetstoriaHeaders(vetstoriaHeadersArg),
    }});
}


export function getLinnaeusPracticeGroup(ownersProfileExtras) {
  return ownersProfileExtras?.divisions?.find(
    (practiceGroup) =>
      practiceGroup.partnerCode === LINNAEUS,
  );
}

export async function getActivities() {
  return await baasOwner.get('/pets/activities');
}

export async function getBehaviors() {
  return await baasOwner.get('/pets/behaviors');
}

export async function getBreeds() {
  return await baasOwner.get('/pets/breeds');
}

export async function getPetProfile(petId) {
  return await baasOwner.get(`/pet_profile/${petId}`);
}

export function deleteAllergiesConditions(petId, data) {
  return baasOwner.patch(`/pet_profile/${petId}`, data);
}

export function getPetFoods(query) {
  return baasOwner.get(`/petfoods/${query}`);
}

export function addPetFood(petId, data) {
  return baasOwner.post(`/pet_profile/${petId}/foods`, data);
}

export function deletePetFood(petId, foodId) {
  return baasOwner.delete(`/pet_profile/${petId}/foods/${foodId}`);
}

export function getPetVaccinations(petId) {
  return baasOwner.get(`/vaccines/${petId}`);
}

export function petPatch(petId, data) {
  return baasOwner.patch(`/pet_profile/${petId}`, data);
}

export function deletePetVaccination(petId, vaccineType) {
  return baasOwner.delete(`/vaccines/delete/${petId}/${vaccineType}`);
}

export function deleteAllPetVaccination(petId) {
  return baasOwner.delete(`/vaccines/delete_all/${petId}`);
}

export async function getMedicalRecordRequets(petId) {
  return await baasOwner.get(`/medical_records/records_requests/${petId}`);
}

export function updateMedicalRecordRequestStatus(id, status) {
  return baasOwner.patch(`/medical_records/records_request/${id}`, { status });
}

export function setAllergiesAndConditions(petId, data) {
  return baasOwner.patch(`/pet_profile/${petId}`, data);
}

export function deleteAllergiesAndConditions(petId, data) {
  return baasOwner.patch(`/pet_profile/${petId}`, data);
}

export function getActivitiesAndBehaviors(petId, attribute) {
  return baasOwner.get(`//pets/psychographic_attitudinal_behavioral/${petId}/${attribute}`);
}

export function setActivitiesAndBehaviors(petId, attribute, data) {
  return baasOwner.post(`/pets/psychographic_attitudinal_behavioral/${petId}/${attribute}`, data);
}

export function updatePet(petId, weight, microchipId, microchipManufacturer, vaccineRecency) {
  return baasOwner.patch(`/pet_profile/${petId}`, {
    weight,
    microchipId,
    microchipManufacturer,
    vaccineRecency
  });
}

export function editPetVaccination(petId, oldVaccineType, vaccineName, administeredDate, renewalDate, type) {
  return baasOwner.patch(`/pets/${petId}/vaccines/${oldVaccineType}`, {
    vaccineName,
    administeredDate,
    renewalDate,
    type
  });
}

export function uploadDocument(petId, formData) {
  return baasOwner.post(`/documents/${petId}/vet_records/`, formData);
}

export function updateDocumentVetName(documentUrl, value) {
  const data = {
    "vet-name": value,
  };
  return baasOwner.put(`/documents/attributes?documentUrl=${encodeURIComponent(documentUrl)}`, data);
}

export function deletePetProfile(petId) {
  return baasOwner.delete(`pet_profile/${petId}`);
}